import React, { useEffect } from "react";
import Layout from "../../Components/Layout";
import { AdminTableContainer } from "./AdminTableContainer";

const AdminPage: React.FC = () => {
  useEffect(() => {
    const savedTheme = localStorage.getItem("app-theme") || "teal";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  return (
    <Layout>
      <AdminTableContainer />
    </Layout>
  );
};

export default AdminPage;